import React from "react"
import styled from '@emotion/styled';

import { useStaticQuery, graphql} from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import RoundButton from "../../../components/RoundButton";
import CommonSection from "../../../components/CommonSection";
import { useLocalization } from 'gatsby-theme-i18n';
import { parseHTML } from '../../../functions/common';
import * as breakpoint from '../../../styles/breakpoints.module.scss';

const SpecialItem = ({ type }) => {
  const { image } = useStaticQuery(graphql`
    query GoodsCampaign {
      image : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/goods/novelty.jpg"}) {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
    
    }
  `);

  const { t } = useLocalization();

  return (
    <SpecialItemWrapper type={type}>
      <SpecialItemCard>
        <SpecialItemText>
          <span>{parseHTML(t('goods.campaign.label'))}</span>
          <span>{parseHTML(t('goods.campaign.title'))}</span>
          <span>{parseHTML(t('goods.campaign.term'))}</span>
          <span>{parseHTML(t('goods.campaign.description'))}</span>
          <SpecialItemButton color={"#F50057"} size={"medium"} href={t('goods.campaign.button.url')}>{t('goods.campaign.button.label')}</SpecialItemButton>
        </SpecialItemText>
        <SpecialItemImage>
          <GatsbyImage image={getImage(image)} alt={t('goods.campaign.title')}/>
        </SpecialItemImage>
      </SpecialItemCard>
    </SpecialItemWrapper>
  );
};


export default SpecialItem;


const SpecialItemWrapper = styled(CommonSection)`
  position: relative;
  background: none;
  z-index:2;
  > div{
    max-width: calc(976px + 96px);
    padding-top:0;

    ${props => props.type === "home" ? `
      padding-bottom:48px;
    ` : `
      margin-top:-48px;
      padding-bottom:0px;
    `}
    
  }
`;

const SpecialItemCard = styled.div`
  width:100%;
  border: 4px solid #D00F31;
  background: #FFFFFF;
  box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.05), 0px 6px 6px -6px rgba(0, 0, 0, 0.03), 0px 16px 14px -14px rgba(0, 0, 0, 0.03);
  border-radius: 6px;
  padding:52px;
  display:flex;
  align-items:center;
  justify-content:space-between;
  flex-wrap: wrap;

  @media only screen and (max-width: ${breakpoint.smMax}){
    padding:44px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    border: 2px solid #D00F31;
    padding:22px;
  }
`

const SpecialItemImage = styled.div`
  width:320px;

  @media only screen and (max-width: ${breakpoint.smMax}){
    width:100%;
    margin-top:48px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    margin-top:24px;
  }
`

const SpecialItemButton = styled(RoundButton)`
  height:auto;
  font-size: 17px;
  line-height: 24px;
  padding:12px 24px;
  border-radius: 24px;
  box-shadow: 0px 6px 8px -4px rgba(255, 54, 78, 0.5);
  

  @media only screen and (max-width: ${breakpoint.smMax}){
    height:auto;
    padding:12px 24px;
    border-radius: 24px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    width:100%;
    padding:8px 16px;
    height:auto;
    font-size: 14px;
    line-height: 20px;
  }
`

const SpecialItemText = styled.div`
  width: calc(100% - 368px);
  > span{
    display:block;

    &:nth-of-type(1){
      font-weight: 900;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.01em;
      color: #2C2C2E;
      margin-bottom:4px;
    }

    &:nth-of-type(2){
      font-weight: 900;
      font-size: 36px;
      line-height: 48px;
      color: #D00F31;
      margin-bottom:32px;
    }

    &:nth-of-type(3){
      font-weight: 900;
      font-size: 16px;
      line-height: 20px;
      color: #444448;
      margin-bottom:32px;
    }

    &:nth-of-type(4){
      color: #444448;
      font-size: 14px;
      line-height: 150%;
      margin-bottom:32px;
    }
  }
  @media only screen and (max-width: ${breakpoint.smMax}){
    width:100%;
    > span{
      &:nth-of-type(1){
        font-size: 12px;
        line-height: 16px;
        margin-bottom:4px;
      }
      &:nth-of-type(2){
        font-size: 28px;
        line-height: 36px;
        margin-bottom:32px;
      }
      &:nth-of-type(3){
        font-size: 16px;
        line-height: 20px;
        margin-bottom:32px;
      }
      &:nth-of-type(4){
        font-size: 14px;
        line-height: 150%;
        margin-bottom:32px;
      }
    }
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    > span{
      &:nth-of-type(1){
        font-size: 10px;
        line-height: 14px;
        margin-bottom:0px;
      }
      &:nth-of-type(2){
        font-size: 20px;
        line-height: 28px;
        margin-bottom:31px;
      }
      &:nth-of-type(3){
        font-size: 14px;
        line-height: 20px;
        margin-bottom:31px;
      }
      &:nth-of-type(4){
        font-size: 14px;
        line-height: 20px;
        margin-bottom:31px;
      }
    }
  }
`
